import {CommandResult} from "../../common/helpers/CommandResult";
import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";
import {MarketingList} from "../model/MarketingList";

export const putMarketingList = (id: number, marketingList: Partial<MarketingList>): Promise<CommandResult> => {
    return AxiosClientFactory
        .getInstance()
        .put(`/api/marketinglists/${id}`, marketingList)
        .then((result) => new CommandResult(result));
};